<template>
  <th
    :rowspan="rowspan"
    :scope="scope"
    :class="{indicator: cellType === 'Indicator'}"
  >
    <template v-if="cellType === 'Indicator'">
      <span v-html="indicatorWithSearchHighlight"/>
      <template v-if="showYear">
        <br>{{ year }}
      </template>
      <br><a
        :href="definitionUrl"
        target="_blank"
        class="links">View Definition</a>
      <span v-if="!printerFriendly"> | </span>
      <router-link
        v-if="!printerFriendly"
        :to="viewAllLocationsUrl"
        class="links"
        @click.native="viewAllLocationsClicked">
        View all locations
      </router-link>
    </template>
    <template v-if="cellType === 'DataType'">
      <span
        v-html="dataTypeWithSearchHighlights"
      />
      <template v-if="showCI"><br>({{ ciLabel }})</template>
      <template v-if="showWN"><br>{{ sampleSizeLabel }}</template>
    </template>
  </th>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import helper from '../../helper';

export default {

  props: {
    cellType: {
      type: String,
      default: 'Indicator',
    },
    rowspan: {
      type: Number,
      default: 1,
    },
    questionId: {
      type: String,
      default: '',
    },
    dataValueTypeId: {
      type: String,
      default: '',
    },
    categoryId: {
      type: String,
      default: '',
    },
    yearId: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      lku: state => state.lku,
      footnotes: state => state.footnotes,
      dataTypes: state => state.dataTypes,
      searchString: state => state.CR.searchString,
      showCI: state => state.CR.reportOptionsGo.showCI,
      showWN: state => state.CR.reportOptionsGo.showWN,
      reportType: state => state.CR.GSGo.reportType,
    }),
    printerFriendly() {
      return this.$store.getters.printerFriendly;
    },
    scope() {
      return this.rowspan > 1 ? 'rowgroup' : 'row';
    },
    indicatorName() {
      const row = this.lku.Question[this.questionId];
      return row ? row.name : '';
    },
    dataTypeRow() {
      return this.dataTypes[this.dataValueTypeId];
    },
    dataTypeName() {
      return this.dataTypeRow ? this.dataTypeRow.dataRowLabel : '';
    },
    ciLabel() {
      return this.dataTypeRow ? this.dataTypeRow.confidenceIntervalLabel : '';
    },
    sampleSizeLabel() {
      return this.dataTypeRow ? this.dataTypeRow.sampleSizeLabel : '';
    },
    definitionUrl() {
      const row = _(this.footnotes).find({ type: 'IndicatorDefinition', qc: this.questionId });
      return row ? helper.convertRelativeUrlToWCMSUrl(row.url) : '';
    },
    viewAllLocationsUrl() {
      return `/LP?CategoryId=${this.categoryId}&IndicatorId=${this.questionId}`;
    },
    indicatorWithSearchHighlight() {
      if (!this.searchString) return this.indicatorName;
      return this.addSearchHighlights(this.indicatorName);
    },
    dataTypeWithSearchHighlights() {
      if (!this.searchString) return this.dataTypeName;
      return this.addSearchHighlights(this.dataTypeName);
    },
    showYear() {
      return this.reportType === 'Locations' || this.reportType === 'Demographics';
    },
    year() {
      const row = this.lku.Year[this.yearId];
      return row ? row.name : '';
    },
  },
  methods: {
    viewAllLocationsClicked() {
      // the @click.native modifier is needed when using a router-to instead of a normal <a> link
      // for this event handler to fire per https://github.com/vuejs/vue-router/issues/800#issuecomment-254623582

      // set initialPageLoad to true so LP will use the query string parm
      this.$store.commit('setInitialPageLoad', true);
      // triggerOmnitureInteractions(`${process.env.InteractionIdentifier}-LB VA,${this.GSGo.locationId},${this.GSGo.categoryId},${this.indicatorIdsForInteraction}`);
    },
    addSearchHighlights(str) {
      const re = new RegExp(this.searchString, 'ig');
      return str.replace(re, match => `<span class="highlight">${match}</span>`);
    },
  },
};
</script>

<style scoped>
  .indicator {
    text-align: left;
    padding-left: .5rem;
  }
  .links {
    text-decoration: underline;
  }
  .links:hover {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/CR/CRTableIndicatorDataTypeCell.vue